<style scoped lang="less">
.popup{
  position: relative;
  &__control{
    box-sizing: border-box;
    padding: 20px;
    position: absolute;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    &__text{
      color: #e9ebf4;
    }
    &__close{
      color: #e9ebf4;
    }
  }
  &__image{
    width: 100%;
    object-fit: contain;
    object-position: top;
  }
  &__pay{
    position: absolute;
    left: 0;
    bottom: 0;
    height: 150px;
    width: 100%;
  }
}
</style>
<script>
import singlePay from "@/helper/singlePay";

export default {
  name: "tempDayPack",
  computed: {
    show: (_this = this) => !!_this.$store.state.showTrialPack,
  },
  methods:{
    singlePay,
    close(){
      this.$store.commit('showTrialPackDialog',false)
    },
  },
}
</script>
<template>
  <van-popup position="top" round :value="show" @click-overlay="close" :close-on-click-overlay="false">
    <div class="popup">
      <div class="popup__control">
        <div class="popup__control__close" @click="close">关闭</div>
      </div>
      <img src="https://s6.bihukankan.com/img/16980576361.png" class="popup__image" alt="">
      <div class="popup__pay" @click="singlePay(113)"/>
    </div>
  </van-popup>
</template>

